import { AccountInfo, InteractionRequiredAuthError, IPublicClientApplication, PublicClientApplication } from '@azure/msal-browser';
import { getLoginRequests, msalConfig } from "../authConfig";

export const msalInstance = new PublicClientApplication(msalConfig);

export const loginUser = async (hasAccount: boolean, instance: IPublicClientApplication) => {
    if (msalConfig.enabled && !hasAccount) {
        await instance.loginRedirect(getLoginRequests()[0]);
    }
}

export const getAccessTokens = async (instance: IPublicClientApplication, account: AccountInfo) => {
    const accessTokens = {};
    const loginRequests = getLoginRequests();

    for (const loginRequest of loginRequests){
        try {
            const accountAuthInfo = await instance.acquireTokenSilent({
                ...loginRequest,
                account,
            });
            accessTokens[loginRequest.scopes[0]] = `bearer ${accountAuthInfo.accessToken}`;

        } catch (error) {
            if (error instanceof InteractionRequiredAuthError) {
                await instance.acquireTokenRedirect(loginRequest);
            } else {
                console.error('Token acquisition error:', error);
            }
        } 

    }

    return accessTokens;
}

export const getDummmyAccessTokens = () => {
    var accessTokens = {};
    const loginRequests = getLoginRequests();

    for (const loginRequest of loginRequests){
        accessTokens[loginRequest.scopes[0]] = `N/A`;
    }

    return accessTokens;
}
